import { negate } from 'lodash';
export const Just = (value)=>[
        'just',
        value
    ];
const _Nothing = [
    'nothing'
];
export const Nothing = ()=>_Nothing;
export const ofNullable = (value)=>value == null ? Nothing() : Just(value);
export const valueOf = (maybe)=>maybe[0] === 'nothing' ? null : maybe[1];
export const isEmpty = ([type])=>type === 'nothing';
export const isPresent = negate(isEmpty);
export const map = (mapper)=>(maybe)=>maybe[0] === 'nothing' ? Nothing() : Just(mapper(maybe[1]));
export const mapTo = (value)=>map(()=>value);
export const orElse = (otherwise)=>(maybe)=>maybe[0] === 'nothing' ? otherwise : maybe[1];
export const orUndefined = (maybe)=>maybe[0] === 'nothing' ? undefined : maybe[1];
export const flatten = (deep)=>deep[0] === 'nothing' ? Nothing() : deep[1];
export const flatMap = (mapper)=>(maybe)=>flatten(map(mapper)(maybe));
export const filter = (predicate)=>flatMap((x)=>predicate(x) ? Just(x) : Nothing());
export const ifPresent = (action)=>(maybe)=>{
        if (maybe[0] === 'just') {
            action(maybe[1]);
        }
        return maybe;
    };
export const ifEmpty = (action)=>(maybe)=>{
        if (maybe[0] === 'nothing') {
            action();
        }
        return maybe;
    };
